"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3379],{

/***/ 13379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uT": function() { return /* binding */ FeatureBox_Body; },
  "Hq": function() { return /* binding */ FeatureBox_CSSHeaderPositionTop; },
  "Ob": function() { return /* binding */ FeatureBox; },
  "h4": function() { return /* binding */ Header; },
  "xv": function() { return /* binding */ Text; },
  "Dx": function() { return /* binding */ Title; },
  "ZP": function() { return /* binding */ FeatureBox_FeatureBox; }
});

// UNUSED EXPORTS: CSSHeaderPositionLeft

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/foundations/Theme/index.ts + 30 modules
var Theme = __webpack_require__(46630);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/components/FeatureBox/FeatureBox.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}




var StyledTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1x0iqjq4"
} : 0)( true ? {
  name: "vmwq2k",
  styles: "margin:0;transition:color 0.6s ease"
} : 0);
var StyledText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1x0iqjq3"
} : 0)( true ? {
  name: "vmwq2k",
  styles: "margin:0;transition:color 0.6s ease"
} : 0);
var Body = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1x0iqjq2"
} : 0)( true ? {
  name: "1nai2ay",
  styles: "display:grid;row-gap:8px;grid-area:body"
} : 0);
var StyledHeader = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1x0iqjq1"
} : 0)( true ? {
  name: "1xb5ze1",
  styles: "grid-area:header;transition:color 0.6s ease"
} : 0);
var CSSHeaderPositionLeft =  true ? {
  name: "1mx6w1u",
  styles: "display:grid;grid-template:'header body';grid-template-columns:44px auto;column-gap:24px"
} : 0;
var CSSHeaderPositionTop =
/*#__PURE__*/

/*#__PURE__*/
(0,emotion_react_browser_esm/* css */.iv)("display:grid;align-content:start;grid-template:'header' auto 'body' auto;row-gap:24px;", Theme/* default.breakpoints.up */.ZP.breakpoints.up("md"), "{row-gap:32px;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);

var _ref =  true ? {
  name: "1ou0jb8",
  styles: "text-align:left;justify-items:left;justify-content:left"
} : 0;

var _ref2 =  true ? {
  name: "1rgxf8c",
  styles: "text-align:center;justify-items:center;justify-content:center"
} : 0;

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1x0iqjq0"
} : 0)("display:grid;width:100%;", function (_ref3) {
  var alignment = _ref3.alignment;
  return alignment === "center" && _ref2;
}, " ", function (_ref4) {
  var alignment = _ref4.alignment;
  return alignment === "left" && _ref;
}, " ", function (_ref5) {
  var headerPosition = _ref5.headerPosition;
  return headerPosition === "left" && CSSHeaderPositionLeft;
}, " ", function (_ref6) {
  var headerPosition = _ref6.headerPosition;
  return headerPosition === "top" && CSSHeaderPositionTop;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/FeatureBox/FeatureBox.tsx


var _excluded = ["children", "headerPosition", "alignment", "tag", "appearance"],
    _excluded2 = ["tokens", "children", "className", "variant", "tag", "appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var FeatureBox = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      headerPosition = _ref.headerPosition,
      _ref$alignment = _ref.alignment,
      alignment = _ref$alignment === void 0 ? "center" : _ref$alignment,
      tag = _ref.tag,
      externalAppearance = _ref.appearance,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, _objectSpread(_objectSpread({
    as: tag,
    ref: ref,
    headerPosition: headerPosition,
    alignment: alignment
  }, rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: appearance,
      children: children
    })
  }));
});

var BaseTitle = function BaseTitle(_ref2) {
  var tokens = _ref2.tokens,
      children = _ref2.children,
      className = _ref2.className,
      _ref2$tag = _ref2.tag,
      tag = _ref2$tag === void 0 ? "h3" : _ref2$tag,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? "h5" : _ref2$variant,
      externalAppearance = _ref2.appearance,
      dangerouslySetInnerHTML = _ref2.dangerouslySetInnerHTML;
  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTitle, {
    tokens: tokens,
    appearance: appearance,
    className: className,
    tag: tag,
    variant: variant,
    dangerouslySetInnerHTML: dangerouslySetInnerHTML,
    children: children
  });
};

var Title = (0,useDesignTokens/* withDesignTokens */.Y)(BaseTitle, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.neutrals.white[100]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});

var BaseText = function BaseText(_ref3) {
  var tokens = _ref3.tokens,
      children = _ref3.children,
      className = _ref3.className,
      _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? "pSmall" : _ref3$variant,
      tag = _ref3.tag,
      externalAppearance = _ref3.appearance,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref3, _excluded2);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledText, _objectSpread(_objectSpread({
    tokens: tokens,
    appearance: appearance,
    className: className,
    tag: tag,
    variant: variant
  }, rest), {}, {
    children: children
  }));
};

var Text = (0,useDesignTokens/* withDesignTokens */.Y)(BaseText, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
var Header = function Header(_ref4) {
  var children = _ref4.children,
      className = _ref4.className;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeader, {
    className: className,
    children: children
  });
};
var FeatureBox_Body = Body,
    FeatureBox_CSSHeaderPositionLeft = CSSHeaderPositionLeft,
    FeatureBox_CSSHeaderPositionTop = CSSHeaderPositionTop;

/* harmony default export */ var FeatureBox_FeatureBox = (FeatureBox);

/***/ })

}]);